// extracted by mini-css-extract-plugin
module.exports = {"list":"ListLayout_list__1hlWP","noDataWrap":"ListLayout_noDataWrap__ayBI0","noDataImg":"ListLayout_noDataImg__3b2lm","noDataText":"ListLayout_noDataText__3xeam"};